
import CoinIconViewer from './coiniconviewer'

export default CoinIconViewer;